import { useTheme, useMediaQuery } from '@mui/material';

/**
 * Hook pour detecter si l'utilisateur est sur mobile
 *
 * @returns {Object} { isMobile, isTablet, isDesktop }
 *
 * Breakpoints:
 * - isMobile: < 600px (xs)
 * - isTablet: 600px - 899px (sm)
 * - isDesktop: >= 900px (md+)
 */
const useIsMobile = () => {
  const theme = useTheme();

  // Mobile: < 600px
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Tablet: 600px - 899px
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  // Desktop: >= 900px
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  // Mobile OR tablet (for bottom nav)
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));

  return {
    isMobile,
    isTablet,
    isDesktop,
    isMobileOrTablet,
  };
};

export default useIsMobile;
